import { createContext } from 'react';
import { IAppConfiguration } from '../../models';

const AppConfigurationContext = createContext<IAppConfiguration | undefined>(undefined);

export const AppConfigurationProvider = AppConfigurationContext.Provider;

export default AppConfigurationContext;
